"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getters = {
  module: function module(state) {
    return state.app.module;
  },
  sidebar: function sidebar(state) {
    return state.app.sidebar;
  },
  language: function language(state) {
    return state.app.language;
  },
  isLowResolution: function isLowResolution(state) {
    return state.app.isLowResolution;
  },
  htmlFontBaseSize: function htmlFontBaseSize(state) {
    return state.app.htmlFontBaseSize;
  },
  // permission_tabs: state => state.app.permission_tabs,
  initLoading: function initLoading(state) {
    return state.operate.initLoading;
  },
  hasFirstTimeLoggedIn: function hasFirstTimeLoggedIn(state) {
    return state.operate.hasFirstTimeLoggedIn;
  },
  inprocessing: function inprocessing(state) {
    return state.operate.inprocessing;
  },
  showDetailPage: function showDetailPage(state) {
    return state.operate.showDetailPage;
  },
  dialogMetaDatas: function dialogMetaDatas(state) {
    return state.operate.dialogMetaDatas;
  },
  breadcrumbMetaDatas: function breadcrumbMetaDatas(state) {
    return state.operate.breadcrumbMetaDatas;
  },
  // popoverMetaData: state => state.operate.popoverMetaData,
  refreshView: function refreshView(state) {
    return state.operate.refreshView;
  },
  asyncAction: function asyncAction(state) {
    return state.operate.asyncAction;
  },
  skyLoaders: function skyLoaders(state) {
    return state.operate.skyLoaders;
  },
  relationSearchKeyword: function relationSearchKeyword(state) {
    return state.operate.relationSearchKeyword;
  },
  vncOperate: function vncOperate(state) {
    return state.operate.vncOperate;
  },
  currentAction: function currentAction(state) {
    return state.operate.currentAction;
  },
  taskIds: function taskIds(state) {
    return state.operate.taskIds;
  },
  refreshTimerId: function refreshTimerId(state) {
    return state.operate.refreshTimerId;
  }
};
var _default = getters;
exports["default"] = _default;